import { ReactElement } from 'react'

import { ConnectedSchedule } from '@/connectors'

export const SchedulePage = (): ReactElement => <ConnectedSchedule />
